var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232.1 238.1",
    style: {
      enableBackground: "new 0 0 232.1 238.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C4C4C4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_28923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28923-2",
    d: "M217.8,238.1H48.9c-7.9,0-14.4-6.4-14.4-14.4v-25.5H10.6v-4h27.9v29.5c0,5.7,4.6,10.4,10.4,10.4h168.8 c5.7,0,10.4-4.6,10.4-10.4v-95c0-5.7-4.6-10.4-10.4-10.4H48.9c-5.7,0-10.4,4.6-10.4,10.4v53.5H0v-4h34.6v-49.5 c0-7.9,6.4-14.4,14.4-14.4h168.8c7.9,0,14.4,6.4,14.4,14.4v95C232.1,231.7,225.7,238.1,217.8,238.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Line_112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12342",
    x: 38.6,
    y: 137.4,
    width: 191.8,
    height: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Line_113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12343",
    x: 38.6,
    y: 156.1,
    width: 191.8,
    height: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12342-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28924",
    className: "st0",
    d: "M203.7,212.8h-38.4v-27.7h38.4V212.8z M169.4,208.8h30.4v-19.7h-30.4V208.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Line_114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12344",
    x: 57.4,
    y: 191.5,
    className: "st0",
    width: 82,
    height: 4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Line_115"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12345",
    x: 72.5,
    y: 200.6,
    className: "st0",
    width: 32.1,
    height: 4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Line_116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12346",
    x: 110,
    y: 200.6,
    className: "st0",
    width: 28.8,
    height: 4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Path_28924-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28925",
    className: "st0",
    d: "M128.2,79.4c-2.3,0-4.3-1.8-4.5-4.1l-6.2-70.4c-0.2-2.5,1.6-4.6,4.1-4.8c0.1,0,0.3,0,0.4,0 h19.9c2.5,0,4.5,2,4.5,4.5c0,0.1,0,0.3,0,0.4l-6.6,70.4c-0.2,2.3-2.1,4.1-4.5,4.1L128.2,79.4L128.2,79.4z M122,4 c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.1,0.2-0.1,0.3l6.2,70.4c0,0.2,0.2,0.4,0.5,0.4h7c0.2,0,0.5-0.2,0.5-0.4l6.6-70.4 c0-0.3-0.2-0.5-0.4-0.5c0,0,0,0,0,0L122,4z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12343-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28926",
    className: "st0",
    d: "M131.9,101.1h-0.3c-4.8,0-8.7-3.9-8.7-8.7s3.9-8.7,8.7-8.7l0,0h0.3c4.8,0,8.7,3.9,8.7,8.7 S136.8,101.1,131.9,101.1z M131.6,87.6c-2.6,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7l0,0h0.3c2.6,0,4.7-2.1,4.7-4.7s-2.1-4.7-4.7-4.7 H131.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFailed);
export default __webpack_public_path__ + "static/media/transaction-failed.fbadf5436c48045df7654cffe7ea6c32.svg";
export { ForwardRef as ReactComponent };